import * as React from "react";
import { ActionButton, Persona, PersonaSize, DirectionalHint, IContextualMenuItem } from "@fluentui/react";
import { css } from "@emotion/css";

const styles = css`
  & .user-button--persona {
    padding: 0 var(--small-pad, 2px);
  }

  & .user-button--persona .ms-Persona-initials {
    background-color: var(--main-bg-color, gray) !important;
    background-image: linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3));
  }

  & .user-button--menu-icon {
    display: none;
  }

  @media (forced-colors: active) {
    & .user-button--persona .ms-Persona-initials {
      background-color: Highlight !important;
      background-image: none;
      color: HighlightText;
      forced-color-adjust: none;
    }
  }
`;

export interface IUserButtonProps {
  initials: string;
  name: string;
  onSignOut: (ev: any) => void;
}

export default class UserButton extends React.Component<IUserButtonProps> {
  public render(): JSX.Element {
    const { initials, name, onSignOut } = this.props;

    const menuItems: IContextualMenuItem[] = [];

    menuItems.push({
      key: "signOut",
      text: "Sign Out",
      iconProps: {
        iconName: "SignOut"
      },
      onClick: onSignOut
    });

    return (
      <div className={styles}>
        <ActionButton
          menuProps={{
            directionalHint: DirectionalHint.bottomRightEdge,
            items: menuItems
          }}
          menuIconProps={{ className: "user-button--menu-icon" }}
        >
          <Persona
            title={name}
            imageInitials={initials}
            size={PersonaSize.size32}
            className="user-button--persona"
            hidePersonaDetails
          />
        </ActionButton>
      </div>
    );
  }
}
